import React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Link as GatsbyLink } from 'gatsby';
import { GatsbyImage, GatsbyImageProps } from 'gatsby-plugin-image';

import { HEADER_VARIABLES } from './Header';

import { LAYOUT_VARIABLES } from '../constants';

interface ILogos {
  homeUrl: string;
  headerLogoImage: Pick<GatsbyImageProps, 'image' | 'alt'> | null;
}

const Container = styled.div`
  display: flex;
  height: var(${LAYOUT_VARIABLES.headerLogoHeight});
`;

const HomeLink = styled(GatsbyLink)`
  ${({ theme: { mq } }) => css`
    display: flex;
    position: relative;
    column-gap: 2.5rem;
    align-items: center;
    height: 100%;
    text-decoration: none;
    line-height: 0;

    ${mq.md} {
      column-gap: 1.625rem;
    }
  `}
`;

const LogoContainer = styled.div`
  ${({ theme: { mq } }) => css`
    position: relative;
    width: 6rem;
    height: 4.625rem;

    ${mq.md} {
      width: 4.125rem;
      height: 3.1875rem;
    }
  `}
`;

const Logo = styled(GatsbyImage)`
  position: absolute;
  width: 100%;
  height: 100%;
`;

const LogoText = styled.span`
  ${({ theme: { mq, tp } }) => css`
    transition: all var(${HEADER_VARIABLES.transitionDuration}) ease-out;
    line-height: 1;
    letter-spacing: -0.03em;
    color: var(${HEADER_VARIABLES.logoColor});
    font-size: 3.75rem;

    ${tp.useFont(fonts => fonts.Inter.light)}

    strong {
      ${tp.useFont(fonts => fonts.Inter.semiBold)}
    }

    ${mq.md} {
      font-size: 2.4375rem;
    }
  `}
`;

const Header: React.FC<ILogos> = ({ homeUrl, headerLogoImage }) => (
  <Container>
    <HomeLink to={homeUrl}>
      <LogoContainer>{headerLogoImage ? <Logo {...headerLogoImage} /> : null}</LogoContainer>
      <LogoText>
        <strong>Shakespeare</strong> Music
      </LogoText>
    </HomeLink>
  </Container>
);

export default Header;
